import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./pages/Home";
function App() {
  return (
    <Router>
      <Switch>
        <Route exact path={`${process.env.PUBLIC_URL + "/"}`} component={Home} />
      </Switch>
    </Router>
  );
}

export default App;
